module.exports = __webpack_public_path__ + "static/img/g2.c46ac20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/g2.png
// module id = PytV
// module chunks = 1